import React, { Fragment } from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import { Switch, Route, Redirect } from 'react-router';
import Home from './pages/Home';

const theme = {
  white: '#FFFFFF',
  whiteBackground: '#F9F9F9',
  lightGray: '#b8b8b8',
  gray: '#515151',
  darkGray: '#121212',
  borderGray: '#323131'
};

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=K2D:100,400');

  html {
    box-sizing: border-box;
    height: 100%;
  }
  
  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    padding: 0;
    margin: 0;
    font-family: 'K2D', sans-serif;
    height: 100%;
    background-image: url('/images/background-image.png');
    background-repeat: space repeat;
    background-color: ${props => props.theme.whiteBackground};
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
      monospace;
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  button {
    outline: none;
  }

  p {
    text-align: justify;
  }

  a:hover {
    opacity: .6;
  }
`;

const App = () => (
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <Fragment>
        <GlobalStyle />
        <Switch>
          <Route exact path='/' component={Home} />
          <Redirect to='/' />
        </Switch>
      </Fragment>
    </BrowserRouter>
  </ThemeProvider>
);

export default App;
